import React, { Component } from 'react';
import { connect } from "react-redux";

import {CrossIcon, DownCaretIcon, SearchIcon} from "../icons";
import FiltersList from "./filterList"
import { setSearchQueryAndApply } from "../../core/actions/searching";
import debounce from "../../../utils/debounce";
import { Waypoint } from "react-waypoint";
import { ActiveFilterBar } from "../activeFilterBar";
import { RegisterTableHeadSticky } from "../table/head";
import { setFilterBarContainerWidth, toggleTableHeaderIsFixed } from "../../core/actions/interface";


class FilterBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
        };

        // bind methods so this is correct this when used by children
        this.toggleFilters = this.toggleFilters.bind(this);
        this.fixFilters = this.fixFilters.bind(this);
        this.unFixFilters = this.unFixFilters.bind(this);
    }

    toggleFilters() {
        this.setState((prevState, props) => {
            return {
                expanded: !prevState.expanded
            }
        })
    }

    shouldShowFilterBar(filterableFields, searchableFields) {
        return filterableFields.length > 0 || searchableFields.length > 0 || this.props.children
    }

    fixFilters({currentPosition, previousPosition}) {

        const { dispatch } = this.props;

        const isAbove = currentPosition === Waypoint.above;
        const wasInside = previousPosition === Waypoint.inside;
        if (isAbove && wasInside) {
            dispatch( toggleTableHeaderIsFixed(true) );
        }

    }

    unFixFilters() {
        const { dispatch } = this.props;
        dispatch( toggleTableHeaderIsFixed(false) )
    }


    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(setFilterBarContainerWidth(this.filterBarContainer.offsetWidth + "px"));
    }


    render() {

        const { expanded } = this.state;
        const { filterableFields, searchableFields, tableHeaderIsFixed, filterBarContainerWidth } = this.props;

        const filterBarStyle = {
            width: `${filterBarContainerWidth}`
        };

        return (
            <div>
                { this.shouldShowFilterBar(filterableFields, searchableFields)  ? (
                    <div>
                        <Waypoint
                            onLeave={this.fixFilters}
                            onEnter={this.unFixFilters}
                            topOffset={"103px"}
                        />
                        <div
                            className={`${tableHeaderIsFixed ? "register-filter-bar--fixed" : ""}`}
                            ref={(ref) => this.filterBarContainer = ref}
                            style={filterBarStyle}
                        >
                            <div
                                className={`wrapper u-flex flex--center u-bb-thin u-bt-thin register-filter-bar`}
                            >
                                { filterableFields.length > 0 &&
                                    <FiltersToggle expanded={ expanded } toggleFilters={ this.toggleFilters } />
                                }
                                <div className="u-flex u-ml--auto">
                                    { searchableFields.length > 0 &&
                                        <Search />
                                    }
                                    { this.props.children }
                                </div>
                            </div>
                            { expanded &&
                                <FiltersList />
                            }
                            <ActiveFilterBar />
                            <RegisterTableHeadSticky
                                unHide={tableHeaderIsFixed}
                            />
                        </div>
                    </div>
                ) : (
                    <div>
                        <Waypoint
                            onLeave={this.fixFilters}
                            onEnter={this.unFixFilters}
                            topOffset={"103px"}
                        />
                        <div
                            className={`${tableHeaderIsFixed ? "register-filter-bar--fixed" : ""}`}
                            ref={(ref) => this.filterBarContainer = ref}
                            style={filterBarStyle}
                        >

                            <RegisterTableHeadSticky
                                unHide={tableHeaderIsFixed}
                            />
                        </div>
                    </div>

                )}
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    filterableFields: state.immutableFiltering.fields,
    searchableFields: state.immutableSearching.fields,
    tableHeaderIsFixed: state.mutableInterface.tableHeaderIsFixed,
    filterBarContainerWidth: state.mutableInterface.filterBarContainerWidth,
});

export default connect(mapStateToProps)(FilterBar);


const FiltersToggle = ({ expanded, toggleFilters }) => (
    <div className="u-flex u-flex-1 register-filter-toggle-width">
        <button className="register-filters-trigger btn-reset u-pr--xsmall cursor-pointer u-pos-relative" onClick={ () => toggleFilters() }>
            Filters
            &nbsp;&nbsp;
            { expanded ? <CrossIcon /> : <DownCaretIcon /> }
        </button>
    </div>
);


class SearchForm extends Component {
    constructor(props) {
        super(props);

        const { searchQuery } = this.props;

        this.state = {
            isSearching: searchQuery.length
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChange = debounce(this.handleChange, 250);
        this.handleFocus = this.handleFocus.bind(this);
        this.handleClear = this.handleClear.bind(this);

    }

    handleChange(val) {
        const { dispatch } = this.props;
        dispatch(setSearchQueryAndApply(val));
        this.setState({
            isSearching: val.length
        });
    }

    handleFocus() {
        this.searchInput.focus();
    }

    handleClear() {

        const { dispatch } = this.props;
        dispatch(setSearchQueryAndApply(''));
        this.searchInput.value = '';
        this.setState({
            isSearching: false
        });
    }

    render() {

        const { searchQuery } = this.props;
        const { isSearching } = this.state;

        return (
            <form className="u-flex flex--center u-flex-1 u-pos-relative register-search-bar-width u-mr--small u-mr--0--small"
                  onSubmit={(e) => e.preventDefault()}>
                <div className="u-flex flex--center register-search-bar-width u-flex-1 u-pos-relative">
                    <span className="u-accessible">Search Input</span>
                    <input
                        className={`register-search-bar-input u-flex-1`}
                        type="text"
                        placeholder="Search"
                        defaultValue={searchQuery}
                        onChange={ (ev) => this.handleChange(ev.target.value) }
                        ref={ (ref) => this.searchInput = ref }
                    />
                    <div
                        className={`reset register-search-icon u-flex flex--center u-bg-color-light-grey cursor-pointer ${isSearching ? `u-mr--xsmall` : ``}`}
                        onClick={this.handleFocus}
                    >
                        <SearchIcon/>
                    </div>
                    { isSearching ? (
                        <div
                            className={`reset cursor-pointer`}
                            onClick={this.handleClear}
                        >
                            <CrossIcon />
                        </div>
                    ) : null }
                </div>
            </form>
        )
    }
}

const Search = connect(state => ({ searchQuery: state.mutableSearching.searchQuery }))(SearchForm);
